module.exports = __webpack_public_path__ + "static/media/speaker-page-row-3.99e36318.png";